import React, {Component} from 'react';
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {Form, Row, Col, ControlLabel, FormGroup, FormControl, Button} from 'react-bootstrap';
import {Link} from 'react-router';
import {handleFrameTasks,sendDataForIframe}  from 'shared/sharedMethods';
import config from  '../../config';
import {makeRequest, dispatchAction, displayMessage}  from 'actions';
import {FETCH_SELLER, FETCH_USER, UPDATE_SELLER, UPDATE_USER} from "actions/actionTypes";
import {loadScript} from 'util/Utils';

class SellerReferralsPage extends Component {
    static get contextTypes() {
        return {
            router: React.PropTypes.object.isRequired,
        };
    }

    constructor(props) {
        super(props);
        this.state = {
            SellerOrdersCount: _.get(this.props, ['location', 'query', 'orders_count'], 0),

        }

    }



    componentWillMount() {
        console.log('in referrals page', this.state.SellerOrdersCount, _.get(this.props, ['location', 'query', 'orders_count'], 0));
        if (this.state.SellerOrdersCount) {
            loadScript('https://conjured.co/shopify/referral/widget.js?shop=kid-gear.myshopify.com&cmp=1825')
        }
    }
    componentDidMount() {
        window.addEventListener("message",  this.handleFrameTasks.bind(this));
    }

    componentWillUnmount() {
        window.removeEventListener("message", this.handleFrameTasks);
    }
  handleFrameTasks(event){
           handleFrameTasks.call(this, {event:event, elementID:'referralsPage'}  )
   }



    render() {
        console.log('this state in Referrals', this.state);
        return   <div className="seller-referrals-page" ref={ page => {
                if(page && !this.pageContent) {
                    this.pageContent = page;
                    sendDataForIframe.call(this, 'referralsPage')
                }
            }}>
            <div className="content_wrapper">
                <div className="box --image-box">
                    <div className="absolute-banner">$10 toward your next GoodBuy Gear experience</div>
                    <img src="https://cdn.shopify.com/s/files/1/1540/2631/files/Main_Image.jpg?17250"></img>
                </div>
                <div className="text-boxes-wrapper">
                    <div className="box --text-box">
                        <div>
                            <h2>1 referral</h2>
                            <h2>=</h2>
                            <h2>$10</h2>
                        </div>
                    </div>

                    <div className="box --conjured-box">
                        {this.state.SellerOrdersCount >= 1 ?
                            <div style={{'box-sizing': 'border-box', 'max-width': '100%'}}>
                                <div id="conjured_referral"></div>
                            </div>
                            : <div className="text-block">
                                <h4>A minimum of 1 order is required to enjoy the perks of our referral program.</h4>
                                <Link target="_blank" className="top10 button-primary"
                                      to={'https://goodbuygear.com/collections/all'}>Shop</Link>
                            </div>
                        }
                    </div>
                </div>
            </div>


        </div>

        // return (<div>
        //    <iframe style={{border:'none'}} src={ 'https://goodbuygear.com/pages/refer-your-friends'} height={ '800px'} width={'100%'}/>
        // </div>)
    }

}

function mapStateToProps(state, props) {
    return {
        userReducer: state.userReducer,
    };
}
function mapDispatchToProps(dispatch) {
    return bindActionCreators({makeRequest, dispatchAction, displayMessage}, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(SellerReferralsPage);
